// Copyright 2013 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up,
                              in_order_by=piles.in_order_by, in_suit_wrap_order=piles.in_suit_wrap_order,
                              in_numeric_order=piles.in_numeric_order, in_numeric_wrap_order=piles.in_numeric_wrap_order,
                              drag_max_given_free=piles.drag_max_given_free;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.fourseasons = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.foundation = [];
        for (var c=1; c<=4; c++)
            this.foundation.push(new this.foundation_pile("foundation"+c, this))

        this.tableau = [];
        for (var c=1; c<=5; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this))

        this.stock = new pile("stock", this);
        this.waste = new pile("waste", this);
        this.create_deck(this.stock, this.waste, 1, 0);
        this.stock.xoffset = .1/90;
        this.stock.yoffset = .1/131;
    }

    static variants = { vanishingcross: { alias: "fourseasons" } };

    foundation_pile = class extends pile_game.generic_foundation {
        constructor(div,game) {
            super(div,game,true);
        }
        accept_stacks = false;
        accept(card) {
                    return this.pile.length == 0 && card.rank == this.start ||
                           this.pile.length      && in_suit_wrap_order(this.top(), card) ? 10 + this.icon_bonus(card) : 0;
        }
    };

    tableau_pile = class extends pile {
        accept_stacks = true
        can_drag(index) { return in_order_by(in_numeric_order, this.pile, index)
                                 && this.pile.length - index <= drag_max_given_free(this.game.tableau); }
        accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.tableau, this) ? 1 :
                           this.pile.length != 0 && in_suit_wrap_order(cards[0], this.top())                   ? 3 :
                           this.pile.length != 0 && in_numeric_wrap_order(cards[0], this.top())                ? 2 : 0;
        }
        xoffset = .5/90;
        yoffset = .5/131;
        maxstack = 13;
    };

    deal(deck) {
            var c;
            this.stock.pile = deck;
            for (var cr in this.tableau) {
                this.tableau[cr].push(c = this.stock.pop());
                c.face = up;
            }

            this.foundation[0].push(c = this.stock.pop());
            c.face = up;
            for (var i in this.foundation)
                this.foundation[i].start = c.rank;
    }

    is_complete() {
            return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                   this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON || NOT_COMPLETE;
    }

    score() {
            return this.count_cards_in(this.foundation);
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau, [this.waste]]);
    }

    layout = grid([{padding: .15},
                   "stock",   "foundation1", "tableau4", "foundation2"],
                  ["waste",   "tableau1",    "tableau2", "tableau3"],
                  [undefined, "foundation3", "tableau5", "foundation4"]);
}

module.exports = solitaire.fourseasons;
// Copyright 2013 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up,
                              in_order_by=piles.in_order_by, in_suit_wrap_order=piles.in_suit_wrap_order,
                              in_numeric_order=piles.in_numeric_order, in_numeric_wrap_order=piles.in_numeric_wrap_order,
                              drag_max_given_free=piles.drag_max_given_free;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.fourseasons = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.foundation = [];
        for (var c=1; c<=4; c++)
            this.foundation.push(new this.foundation_pile("foundation"+c, this))

        this.tableau = [];
        for (var c=1; c<=5; c++)
            this.tableau.push(new this.tableau_pile("tableau"+c, this))

        this.stock = new pile("stock", this);
        this.waste = new pile("waste", this);
        this.create_deck(this.stock, this.waste, 1, 0);
        this.stock.xoffset = .1/90;
        this.stock.yoffset = .1/131;
    }

    static variants = { vanishingcross: { alias: "fourseasons" } };

    foundation_pile = class extends pile_game.generic_foundation {
        constructor(div,game) {
            super(div,game,true);
        }
        accept_stacks = false;
        accept(card) {
                    return this.pile.length == 0 && card.rank == this.start ||
                           this.pile.length      && in_suit_wrap_order(this.top(), card) ? 10 + this.icon_bonus(card) : 0;
        }
    };

    tableau_pile = class extends pile {
        accept_stacks = true
        can_drag(index) { return in_order_by(in_numeric_order, this.pile, index)
                                 && this.pile.length - index <= drag_max_given_free(this.game.tableau); }
        accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.tableau, this) ? 1 :
                           this.pile.length != 0 && in_suit_wrap_order(cards[0], this.top())                   ? 3 :
                           this.pile.length != 0 && in_numeric_wrap_order(cards[0], this.top())                ? 2 : 0;
        }
        xoffset = .5/90;
        yoffset = .5/131;
        maxstack = 13;
    };

    deal(deck) {
            var c;
            this.stock.pile = deck;
            for (var cr in this.tableau) {
                this.tableau[cr].push(c = this.stock.pop());
                c.face = up;
            }

            this.foundation[0].push(c = this.stock.pop());
            c.face = up;
            for (var i in this.foundation)
                this.foundation[i].start = c.rank;
    }

    is_complete() {
            return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                   this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON || NOT_COMPLETE;
    }

    score() {
            return this.count_cards_in(this.foundation);
    }

    complete() {
            return this.complete_generic(this.foundation, [this.tableau, [this.waste]]);
    }

    layout = grid([{padding: .15},
                   "stock",   "foundation1", "tableau4", "foundation2"],
                  ["waste",   "tableau1",    "tableau2", "tableau3"],
                  [undefined, "foundation3", "tableau5", "foundation4"]);
}

module.exports = solitaire.fourseasons;
